// extracted by mini-css-extract-plugin
export default {"flex":"flex-d0d5","min-money-width":"min-money-width-99fa","small":"small-d83d","large":"large-99bb"};